import { KHATTABAT_MATCHING_RESULTS_LIMIT } from "../../../../../constants/picker-entries-constants";
import i18n from "../../../../../constants/i18n";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-store";
import { TEt3PickerSingleValue } from "../../../../../TypesNEW";
import Et3Button from "../../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Picker from "../../../../../core/et3-input/et3-picker";
import FormSectionWrapper from "./FormSectionWrapper";

const FormActions = withLiteObserverAndTheme(() => {
  return (
    <FormSectionWrapper>
      <Et3Picker
        label={i18n.get("RESULTS_NUMBER")}
        options={KHATTABAT_MATCHING_RESULTS_LIMIT}
        value={getKhattabatMatchingStore().matchesIdsResultLimit.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getKhattabatMatchingStore().setMatchesIdsResultLimit(value);
        }}
        isMultiple={false}
        style={{ position: "relative" }}
        onEnter={() => { }}
        onClick={() => { }}
        containerStyle={{}}
      />
      <Et3Button
        isEnabled={getKhattabatMatchingStore().canGetMatches()}
        onClick={async () => {
          await getKhattabatMatchingStore().getMatchesIds();
        }}
        size="LARGE"
        type="GET"
        text="GET"
      />
      <Et3Button
        isEnabled={getKhattabatMatchingStore().isActiveFilter.get()}
        onClick={async () => {
          getKhattabatMatchingStore().resetFilter();
        }}
        size="LARGE"
        type="REJECT"
        text="CLEAR_RESULTS"
      />
    </FormSectionWrapper>
  );
});

export default FormActions;
